// extracted by mini-css-extract-plugin
module.exports = {"root":"Style_root__1w9zT","content":"Style_content__3ZBja","item":"Style_item__2NPp1"};